import { CanDeactivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

export interface ChatPageNavigationView {
  dismissTransientBackContext(): boolean;
  hasSelectedConversation(): boolean;
  canReturnTo(url: string): boolean;
  confirmVoiceRecordingExit(): boolean | Promise<boolean>;
}

export const preserveChatVoiceRecording: CanDeactivateFn<
  ChatPageNavigationView
> = (component) => component.confirmVoiceRecordingExit();

export const preserveChatBackContext: CanDeactivateFn<
  ChatPageNavigationView
> = (component, _currentRoute, _currentState, nextState) => {
  const router = inject(Router);
  const navigation = router.getCurrentNavigation();

  if (navigation?.trigger !== 'popstate') {
    return true;
  }

  if (component.dismissTransientBackContext()) {
    return false;
  }

  if (component.canReturnTo(nextState.url)) {
    return true;
  }

  const nextPath = nextState.url.split(/[?#]/, 1)[0];
  if (component.hasSelectedConversation() && nextPath !== '/chat') {
    return router.parseUrl('/chat');
  }

  return true;
};
